/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxComboBoxComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxcombobox';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcComboBoxComponent),
    multi: true
};

/**
 * Combo Box
 */
@Component({
    selector: 'ngc-combobox',
    template: `<jqxComboBox *ngIf="visible" (change)="inputChange($event)" (onSelect)="select($event)"
                [animationType] = "animationType"
                [autoComplete] = "autoComplete"
                [autoOpen] = "autoOpen"
                [autoItemsHeight] = "autoItemsHeight"
                [autoDropDownHeight] = "autoDropDownHeight"
                [closeDelay] = "closeDelay"
                [checkboxes] = "checkboxes"
                [disabled] = "disabled"
                [displayMember] = "displayMember"
                [dropDownHorizontalAlignment] = "dropDownHorizontalAlignment"
                [dropDownVerticalAlignment] = "dropDownVerticalAlignment"
                [dropDownHeight] = "dropDownHeight"
                [dropDownWidth] = "dropDownWidth"
                [enableHover] = "enableHover"
                [enableSelection] = "enableSelection"
                [enableBrowserBoundsDetection] = "enableBrowserBoundsDetection"
                [itemHeight] = "itemHeight"
                [multiSelect] = "multiSelect"
                [minLength] = "minLength"
                [openDelay] = "openDelay"
                [popupZIndex] = "popupZIndex"
                [placeHolder] = "placeHolder"
                [remoteAutoComplete] = "remoteAutoComplete"
                [remoteAutoCompleteDelay] = "remoteAutoCompleteDelay"
                [renderer] = "renderer"
                [renderSelectedItem] = "renderSelectedItem"
                [rtl] = "rtl"
                [selectedIndex] = "selectedIndex"
                [showArrow] = "showArrow"
                [showCloseButtons] = "showCloseButtons"
                [searchMode] = "searchMode"
                [search] = "search"
                [source] = "source"
                [scrollBarSize] = "scrollBarSize"
                [template] = "template"
                [theme] = "theme"
                [validateSelection] = "validateSelection"
                [valueMember] = "valueMember"
                [width] = "width"
                [height] = "height">
                </jqxComboBox>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcComboBoxComponent extends ControlComponent {
    @Input('animationType') animationType: any;
    @Input('autoComplete') autoComplete: any;
    @Input('autoOpen') autoOpen: any;
    @Input('autoItemsHeight') autoItemsHeight: any;
    @Input('autoDropDownHeight') autoDropDownHeight: any;
    @Input('closeDelay') closeDelay: any;
    @Input('checkboxes') checkboxes: any;
    @Input('displayMember') displayMember: any;
    @Input('dropDownHorizontalAlignment') dropDownHorizontalAlignment: any;
    @Input('dropDownVerticalAlignment') dropDownVerticalAlignment: any;
    @Input('dropDownHeight') dropDownHeight: any;
    @Input('dropDownWidth') dropDownWidth: any;
    @Input('enableHover') enableHover: any;
    @Input('enableSelection') enableSelection: any;
    @Input('enableBrowserBoundsDetection') enableBrowserBoundsDetection: any;
    @Input('itemHeight') itemHeight: any;
    @Input('multiSelect') multiSelect: any;
    @Input('minLength') minLength: any;
    @Input('openDelay') openDelay: any;
    @Input('popupZIndex') popupZIndex: any;
    @Input('placeHolder') placeHolder: any;
    @Input('remoteAutoComplete') remoteAutoComplete: any;
    @Input('remoteAutoCompleteDelay') remoteAutoCompleteDelay: any;
    @Input('renderer') renderer: any;
    @Input('renderSelectedItem') renderSelectedItem: any;
    @Input('rtl') rtl: any;
    @Input('selectedIndex') selectedIndex: any;
    @Input('showArrow') showArrow: any;
    @Input('showCloseButtons') showCloseButtons: any;
    @Input('searchMode') searchMode: any;
    @Input('search') search: any;
    @Input('source') source: any;
    @Input('scrollBarSize') scrollBarSize: any;
    @Input('template') template: any;
    @Input('theme') theme: any;
    @Input('validateSelection') validateSelection: any;
    @Input('valueMember') valueMember: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }

    /**
     * On Select
     * 
     * @param Event
     */
    select($e) {
        if ($e.args.item !== null) {
            this.value = $e.args.item.value;
        }
    }
}

/**
 * Combo Box Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcComboBoxComponent],
    declarations: [NgcComboBoxComponent, jqxComboBoxComponent]
})
export class NgcComboBoxModule {
}